import React, { FC } from 'react';
import { AudioPlayer } from './AudioPlayer';
import { MessageReadStatus } from 'src/screens/OnboardingTrainer/screens/Dashboard/screens/Messages/components/MessageReadStatus';
import { ChatMessage } from 'src/screens/OnboardingTrainer/screens/Dashboard/screens/Messages/types';

export interface AudioMessageBubbleProps {
  message: ChatMessage;
  isSentByTrainer: boolean;
  timeStr: string;
  renderTextWithLinks?: (text: string) => React.ReactNode;
}

export const AudioMessageBubble: FC<AudioMessageBubbleProps> = ({
  message,
  isSentByTrainer,
  timeStr,
  renderTextWithLinks,
}) => {
  const audioSrc = message.audio_url || message.media_url || '';
  const duration = message.audio_duration_seconds;

  return (
    <div className={`audio-message-bubble-box ${isSentByTrainer ? 'sent' : 'received'}`}>
      <div className="audio-bubble-card">
        {audioSrc && (
          <AudioPlayer
            src={audioSrc}
            durationSeconds={duration}
            theme={isSentByTrainer ? 'sent' : 'received'}
          />
        )}

        {/* Optional text caption accompanying the voice note */}
        {Boolean(message.body && message.body.trim()) && (
          <div className="audio-caption-text">
            {renderTextWithLinks ? renderTextWithLinks(message.body) : message.body}
          </div>
        )}
      </div>

      <div className="message-meta">
        <MessageReadStatus isRead={!!message.is_read} isSentByTrainer={isSentByTrainer} />
        <span>{timeStr}</span>
      </div>
    </div>
  );
};
